export const errorMessage = {
  EMPTY_FIELD: 'This field must be filled',
  LATIN: 'Name should contain latin letters only',
  INCORRECT_EMAIL: 'Incorrect email format',
  CONFIRM_PASSWORD: "Passwords don't match",
  FORBIDDEN_COUNTRY: 'Sorry, we don’t offer services in this country',
  RECOMMENDATION_CORPORATE_MAIL: 'We suggest using a corporate email rather than a private one',
  EMAIL_IS_ALREADY_REGISTERED: 'This email is already registered, please choose another one',
  UNIQUE_WALLET: 'A wallet for this currency has already been created',
  CURRENCY_IS_NOT_UNIQUE: 'The settlement address for this currency is already exist',
  BENEFICIARY_NAME_IS_NOT_UNIQUE: 'Beneficiary name is already used',
  BANK_ACCOUNT_NUMBER_IS_NOT_UNIQUE: 'Bank Account Number name is already used',
}
